import { render, staticRenderFns } from "./DefenceAssociationDialog.vue?vue&type=template&id=2294d3a8&scoped=true"
import script from "./DefenceAssociationDialog.vue?vue&type=script&lang=js"
export * from "./DefenceAssociationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2294d3a8",
  null
  
)

export default component.exports